import { gql } from '@apollo/client';
import HWT_STUDENT_SETTINGS_FRAGMENT from '../../fragments/hwt-student-settings';

const GET_HWT_STUDENT_SETTINGS = gql`
  query hwtStudentSettings($where: PliStudentSettingsWhereInput!) {
    hwtStudentSettings(where: $where) {
      ...BaseHwtStudentSettings
    }
  }
  ${HWT_STUDENT_SETTINGS_FRAGMENT}
`;

export default GET_HWT_STUDENT_SETTINGS;
